import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/trainings/pages/settings/RootPage'))

const settingRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      handle: {
        meta() {
          return {
            title: i18n.t('trainings.settings.page_title'),
          }
        },
      },
      path: navigation.settings.trainings.path,
      element: <RootPage />,
    },
  ]
}

export default settingRoutes
